module.exports = __webpack_public_path__ + "img/bin.9842d7f3.svg";